'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useReducer, } from 'react';
const initialState = {};
var ActionType;
(function (ActionType) {
    ActionType[ActionType["SUSPENSION_STARTED"] = 0] = "SUSPENSION_STARTED";
    ActionType[ActionType["SUSPENSION_FINSHED"] = 1] = "SUSPENSION_FINSHED";
})(ActionType || (ActionType = {}));
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionType.SUSPENSION_STARTED: {
            return Object.assign(Object.assign({}, state), { [action.data]: 'STARTED' });
        }
        case ActionType.SUSPENSION_FINSHED: {
            return Object.assign(Object.assign({}, state), { [action.data]: 'FINISHED' });
        }
    }
};
const SuspensionsContext = createContext(null);
const SuspensionsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const createSuspension = useCallback((handle) => {
        dispatch({ type: ActionType.SUSPENSION_STARTED, data: handle });
    }, []);
    const removeSuspension = useCallback((handle) => {
        dispatch({ type: ActionType.SUSPENSION_FINSHED, data: handle });
    }, []);
    const suspended = useCallback((handle) => state[handle] || null, [state]);
    const value = useMemo(() => ({ suspended, createSuspension, removeSuspension }), [suspended, createSuspension, removeSuspension]);
    return (_jsx(SuspensionsContext.Provider, { value: value, children: children }));
};
function useSuspensions() {
    const context = useContext(SuspensionsContext);
    if (!context)
        throw new Error('useSuspensions requires a context!');
    return context;
}
export { SuspensionsProvider, useSuspensions };
//# sourceMappingURL=suspensions.js.map